import { useEffect } from "react";
import type { AppTag } from "../../../shared/connectors/tags";
import { queries } from "../../../shared/queries";
import { useQuery } from "../../hooks/useQuery";
import { connectorDirectory } from "../../lib/connectorDirectory";
import { navigate, Route, routes, useRouteMatch } from "../../lib/urls";
import { Connected } from "./Connected";
import { ConnectorsLayout } from "./ConnectorsLayout";
import { DirectoryPage } from "./DirectoryPage";
import { DirectoryTabs } from "./DirectoryTabs";

const allTags: AppTag[] = [
  ...new Set(connectorDirectory.flatMap((app) => app.tags)),
].sort();

const paneStyle = (visible: boolean): React.CSSProperties => ({
  display: visible ? "flex" : "none",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
});

export function Connectors() {
  const [isConnected] = useRouteMatch(routes.connectors.connected);
  const [isDirectory] = useRouteMatch(routes.connectors.directory);

  return (
    <>
      <Route path={routes.connectors}>
        <RedirectBasedOnConnectors />
      </Route>
      <ConnectorsLayout
        headerItem={isDirectory ? <DirectoryTabs tags={allTags} /> : undefined}
      >
        <div style={paneStyle(isConnected)}>
          <Connected active={isConnected} />
        </div>
        <div style={paneStyle(isDirectory)}>
          <DirectoryPage active={isDirectory} />
        </div>
      </ConnectorsLayout>
    </>
  );
}

function RedirectBasedOnConnectors() {
  const [isConnected] = useRouteMatch(routes.connectors.connected);
  const [isDirectory] = useRouteMatch(routes.connectors.directory);
  const [connectors] = useQuery(queries.connectedAppsIndex());

  useEffect(() => {
    if (!isConnected && !isDirectory) {
      if (connectors.length === 0) {
        navigate(routes.connectors.directory, undefined, { replace: true });
      } else {
        navigate(routes.connectors.connected, undefined, { replace: true });
      }
    }
  }, [isConnected, isDirectory, connectors.length]);

  return null;
}
